import styled from 'styled-components';

export const TooltipText = styled.div`
  background: transparent;
  color: #102A63;
  text-align: center;
  line-height: 44px;
  border-radius: 3px;
  cursor: pointer;
  width: 15%;

  &.active{
    color: #112A61;
  }

  &:hover{
    color: #112A61;
  }
`;

export const TooltipCard = styled.div`
  position: relative;
`;
